<template>
  <!-- <div v-if="selected" class="accessories-select" :tabindex="tabindex" @blur="open = false"> -->
  <div class="accessories-select">
    <!-- <div class="selected pr-2" :class="{ open: open }" @click="open = !open">
      <div class="d-flex">
        <img style="width: 120px;" alt="Gravsten" :src="getPic('tillbehör/' + selected.file_name)">
        <div class="ml-05">
          <span class="headline">{{ selected.name }}</span>
          <br>
          <span> {{ selected.priceInclVat }} kr</span>
        </div>
      </div>
    </div> -->
    <!-- <div class="items" :class="{ selectHide: !open }"> -->
    <div>
      <template v-for="(option, i) of options" :key="i">
        <div v-if="!(gravestone_orientation == 'lying' && option.name.includes('Blomlist'))" class="item accessories-item border-grey mb-1"  @click="
              selected = option;
              open = false;
              selectAccessories(option)
            ">
          <div :class="'d-flex'">
            <img style="width: 120px;" alt="Gravsten" :src="getPic('tillbehör/' + option.file_name )">
            <div class="ml-05">
              <span class="headline">{{ option.name }}</span>
              <br>
              <span> {{ formatPrice((option.name == 'Blomlist' ? option.priceInclVat * percentageIncrease : option.priceInclVat )) }} kr</span>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- </div> -->
  </div>
  <!-- </div> -->
</template>
<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: Object,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    selectAccessories: Function,
    selectedStonesize: Object,
    percentageIncrease: Number,
    orientation: String
  },
  data() {
    return {
      selected: null,
      open: false,
      gravestone_orientation: ''
    };
  },
  watch: {
    orientation: {
      handler() {
        this.gravestone_orientation = this.orientation;
      },
      deep: true,
    }
  },
  mounted() {
    this.gravestone_orientation = this.orientation;
    this.selected = this.default;
    if (this.selected.dimensions) {
      this.selected.priceInclVat = this.selected.dimensions[this.selectedStonesize.width].priceInclVat;
    }

    this.options.forEach((option) => {
      if (option.dimensions) {
        option.priceInclVat = option.dimensions[this.selectedStonesize.width].priceInclVat;
      }
    })
  },
  methods: {
    getPic(file_name) {
      return process.env.VUE_APP_IMAGE_FOLDER + file_name;
    },
    formatPrice(x) {
      let formatedPrice = x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : x;
      return formatedPrice;
    },
  }
};
</script>
<style scoped>
.accessories-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  min-height: 47px;
}

.accessories-select .selected {
  background-color: #fff;
  border: 1px solid #a5a5a5;
  color: #000;
  cursor: pointer;
  user-select: none;
}

.accessories-select img {
  padding: 0.5rem;
}

.accessories-select .selected:after {
  position: absolute;
  content: "";
  top: 49%;
  right: 1em;
  width: 0;
  height: 0;
  border: 7.5px solid transparent;
  border-color: #000 transparent transparent transparent;
}

.accessories-select .items {
  color: #fff;
  overflow: hidden;
  border: 1px solid #ddd;
  /*border-right: 1px solid #ddd;
  border-left: 1px solid #ddd;
  border-bottom: 1px solid #ddd;*/
  /*position: absolute;*/
  background-color: #fff;
  /*  left: 0;
  right: 0;
  z-index: 1;*/
}

.accessories-select .items div {
  color: #000;
  cursor: pointer;
  user-select: none;
}

.accessories-select .item {
  /*border-bottom: 1px solid #ddd;*/
  background: #fff;
}

.accessories-select .items div:hover {
  background-color: #c3d2d0;
}

.accessories-select .d-flex {
  align-items: center;
}

.accessories-select .headline {
  font-size: 1rem;
}

.stonesize-select .active {
  background: #e1efed;
}

.accessories-item:hover {
  background-color: #c3d2d0;
  cursor: pointer;
}

/*.selectHide {
  display: none;
}*/
</style>